import { TabPanel, Item as TabPanelItem } from 'devextreme-react/tab-panel';
import React, { Component } from 'react';
import VerifyingGrid from './VerifyingGrid';
import Collapsible from 'react-collapsible';
import { Button, CheckBox, DateBox, Popup, Switch } from 'devextreme-react';
import { apiGetP } from '../../GanjiTools';
import Inline from '../Inline';
import RiskMatrix from './RiskMatrix';
import XYPlot from './XYPlot';
import Space from '../Space';
import Spinner from '../utils/Spinner';
import './Results.scss';


class Results extends Component {
    state = {
        loading: true,
        calcResult: { error: 'Not calculated yet.' },
        recalcKey: 1,
        plotKey: 1,
        atDate: new Date(),
        curve: 'risk_f',
    }

    reCalculate = () => {
        if (!(this.props.assetId > 0))
            return;

        this.state.plotKey++;
        this.state.recoms = [];

        let date = new Date(this.state.atDate).toISOString();
        apiGetP(`/api/rbi/calc?assetId=${this.props.assetId}&date=${date ?? ''}&user=${window._tempUser ?? ''}`)
            .catch(err => this.setState({ loading: false, calcResult: { error: err?.toString() }, recalcKey: this.state.recalcKey + 1 }))
            .then(res => this.setState({ loading: false, calcResult: res ?? { error: 'No responce.' }, recalcKey: this.state.recalcKey + 1 }));
    }

    componentDidMount() {
        this.reCalculate();
    }

    renderSettableDate = ymd => (
        <>
            <b>{ymd}</b>
            {ymd?.length > 0 &&
                <span className='set-date-button' onClick={() => this.setState({ atDate: Date.parse(ymd) }, this.reCalculate)}
                >
                    Set
                </span>
            }
        </>
    );

    render() {
        let cr = this.state.calcResult;

        return (this.state.loading ? <div style={{ height: '300px' }} ><Spinner /></div> :
            <>
                <div style={{ height: 'calc(100vh - 160px)', overflowY: 'overlay' }}>
                    <div className='horz-box'>
                        <div style={{ padding: '1rem', width: 'inherit' /*width:100% */ }}>
                            {cr.error?.length > 0 &&
                                <div>
                                    <div style={{ color: 'darkred', fontWeight: '900' }}>Errors: </div>
                                    {cr.error.split('|').map(x => x.trim().replace(';', '')).filter(x => x.length > 2)
                                        .map(x => (
                                            <li style={{ marginLeft: '1rem', color: 'darkred' }}>{x.replace(';', '')}
                                            </li>
                                        ))}
                                    <br />
                                </div>
                            }
                            <table className='results-table'>
                                <tr><td>Calculated Results at <b>{cr.time}</b></td><td>Plan Date = {this.renderSettableDate(cr.planDate)}</td></tr>
                                <tr>
                                    <td>PoF = <b>{cr.pof?.toFixed(4)}</b> ({cr.pof_scat})</td><td>Total Df = <b>{cr.df_total?.toFixed(4)}</b></td>
                                </tr>
                                <tr>
                                    <td>CoF Area = <b>{cr.cof_a?.toFixed(4)}</b> ({cr.ca_scat})</td><td>CoF Financial = <b>{cr.cof_f?.toFixed(4)}</b> ({cr.cf_scat})</td>
                                </tr>
                                <tr>
                                    <td>Risk Area = <b>{cr.risk_a?.toFixed(4)}</b></td><td>Risk Financial = <b>{cr.risk_f?.toFixed(4)}</b></td>
                                </tr>
                                <tr>
                                    <td>Area Target Date = {this.renderSettableDate(cr.targetDate_a)}</td><td>Financial Target Date = {this.renderSettableDate(cr.targetDate_f)}</td>
                                </tr>
                                <tr>
                                    <td>PoF Target Date = {this.renderSettableDate(cr.targetDate_pof)}</td><td>DF-total Target Date = {this.renderSettableDate(cr.targetDate_dftotal)}</td>
                                </tr>
                            </table>
                            <div style={{ padding: '0.5rem 1.5rem', fontWeight: 'bold' }}>Recommended Inspections: {cr.recommendeds_s?.replaceAll(';', '  ⯁ ')}</div>

                            <div className='horz-box'
                                style={{
                                    margin: '5px 0', fontSize: '14px',
                                    width: 'fit-content',/* '100%'*/
                                }}>
                                <Inline spacing='1rem' key={'b' + this.state.recalcKey}>
                                    <label>Date:</label>
                                    <DateBox value={this.state.atDate} displayFormat='yyyy/MM/dd' //showClearButton
                                        onValueChanged={e => this.setState({ atDate: e.value })}
                                        width='12rem' applyValueMode='useButtons'
                                    >

                                    </DateBox>
                                    <Button text='ReCalculate' onClick={this.reCalculate} type='success' width='12rem' />
                                    {cr.testLogs_Cat && cr.recommendeds?.length > 0 &&
                                        <Button text='Apply Recommendations' onClick={() => this.setState({ recoms: cr.recommendeds, plotKey: this.state.plotKey + 1 })}
                                            type='success' width='12rem'
                                        />
                                    }
                                    {cr.testLogs_Cat &&
                                        <Button text='Verify...' onClick={() => this.setState({ verifyPopVisible: true })} type='success' width='12rem' />
                                    }
                                </Inline>
                            </div>
                        </div>
                        {/* <RiskMatrix ca_cat={cr.ca_cat} cf_cat={cr.cf_cat} pof_cat={cr.pof_cat} style={{ width: '400px', padding: '20px' }} /> */}
                    </div>
                    <div className='horz-box' style={{ width: 'inherit'/* 'inherit'*/ }}>
                        <RiskMatrix ca_cat={cr.ca_cat} cf_cat={cr.cf_cat} pof_cat={cr.pof_cat} style={{ /*width: '400px',*/ padding: '20px' }} />
                        {cr.testLogs_Cat &&
                            <XYPlot assetId={this.props.assetId} key={'xyplot' + this.state.plotKey + this.state.curve}
                                atDate={this.state.atDate} curve={this.state.curve} recoms={this.state.recoms} logScale={this.state.logScaleCurves}
                            />
                        }
                    </div>
                    {cr.testLogs_Cat &&
                        <div className='horz-box' style={{ width: 'inherit' }}>
                            <Inline spacing='5px' style={{ margin: '1rem' }}>
                                <Button text='Finantial Risk' width='8rem' type={this.state.curve === 'risk_f' ? 'success' : 'normal'}
                                    onClick={() => this.setState({ curve: 'risk_f' })}
                                />
                                <Button text='Risk Area' width='8rem' type={this.state.curve === 'risk_a' ? 'success' : 'normal'}
                                    onClick={() => this.setState({ curve: 'risk_a' })}
                                />
                                <Button text='PoF' width='8rem' type={this.state.curve === 'pof' ? 'success' : 'normal'}
                                    onClick={() => this.setState({ curve: 'pof' })}
                                />
                                <Button text='Total DF' width='8rem' type={this.state.curve === 'df_total' ? 'success' : 'normal'}
                                    onClick={() => this.setState({ curve: 'df_total' })}
                                />
                                <Space width='1rem' />
                                <CheckBox text='Log Scale' value={this.state.logScaleCurves === true}
                                    onValueChanged={e => this.setState({ logScaleCurves: e.value, plotKey: this.state.plotKey + 1 })}
                                />
                            </Inline>
                        </div>
                    }
                </div>

                <Popup visible={this.state.verifyPopVisible} title='Result Steps Verification' key={'respop_' + this.props.assetId}
                    showCloseButton width='90%' height='fit-content' maxHeight='95vh'
                    onHidden={() => this.setState({ verifyPopVisible: false })}
                >
                    <TabPanel key={'tp' + this.props.assetId}>
                        {cr.testLogs_Cat &&
                            Object.keys(cr.testLogs_Cat).map(oc => (
                                <TabPanelItem title={oc} key={'tpi' + this.props.assetId + '_' + oc}>
                                    <VerifyingGrid ds={cr.testLogs_Cat?.[oc]} assetId={this.props.assetId} cat={oc} />
                                </TabPanelItem>
                            ))
                        }
                    </TabPanel>
                </Popup>
            </>
        );
    }
}

export default Results;